<template>
  <SectionContentLayout 
    content_class="contacts-import"
    :state="contacts_controller.state.events['contacts-import']">
    <template #close>
      <ActionButton
          @click='onClose()'
          v-tooltip='"contacts.actions.close"'
          class="close"
          icon="fas fa-times-circle"
        />
    </template>

    <template #header>
        <ContentTitle title="contacts.import.title"/>
    </template>

    <template #content>
      <div class="form">
          <fieldset>
            <legend>{{ Language.say('contacts.import.select_result.sub_title') }}</legend>
            <p>{{ Language.say('contacts.import.select_result.description', [contacts_import_controller.contacts_list.count]) }}</p>

            <div
              class="contact"
              v-for="contact in contacts_import_controller.contacts_list.items"
              :key="contact.id">
                <div class="control-group">
                    <ul class="control check-group">
                        <li>
                            <input
                              :id="contact.id"
                              type="checkbox"
                              :checked="contact.id in contacts_import_controller.contacts_selection.index"
                              @change="onToggleContactSelection(contact)">
                            <label :for="contact.id"></label>
                        </li>
                    </ul>
                </div>
                <p v-if="contact.name">
                    <small>{{ Language.say('contacts.import.field_label.name') }}</small>
                    <span>{{contact.name}}</span>
                </p>
                <p v-if="contact.email">
                    <small>{{ Language.say('contacts.import.field_label.email') }}</small>
                    <span><a :href="`mail:${contact.email}`">{{contact.email}}</a></span>
                </p>
                <p v-if="contact.mobile_phone">
                    <small>{{ Language.say('contacts.import.field_label.phone') }}</small>
                    <span><a :href="`tel:${contact.mobile_phone}`">{{contact.mobile_phone}}</a></span>
                </p>
                <p v-if="contact.home_address">
                    <small>{{ Language.say('contacts.import.field_label.address') }}</small>
                    <span>{{contact.home_address}}</span>
                </p>
                <p v-if="contact.company">
                    <small>{{ Language.say('contacts.import.field_label.company') }}</small>
                    <span>{{contact.company}}</span>
                </p>
                <p v-if="contact.birth_date">
                    <small>{{ Language.say('contacts.import.field_label.birthday') }}</small>
                    <span>{{contact.birth_date}}</span>
                </p>
            </div>
        </fieldset>

        <div class="submit-desktop">
            <p>{{ Language.say('contacts.import.select_result.check_message') }}</p>
            <ActionButton :text="Language.say('contacts.import.button_actions.cancel')"
              @click="onResetImport()"  />
            <ActionButton
              class="main-action"
              :text="Language.say('contacts.import.button_actions.import')"
              @click="onImportContacts()"
              :class="{disabled: contacts_import_controller.contacts_selection.count === 0}" />
        </div>

      </div>
    </template>
  </SectionContentLayout>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue'
  import SectionContentLayout from '@/vue/Layouts/Sections/SectionContentLayout.vue';
  import Language from '@/js/Shared/Language/Language';
  import ActionButton from '@/vue/Elements/Buttons/ActionButton.vue';
  import ContentTitle from '@/vue/Elements/Content/ContentTitle.vue';
  import ContactsController from '@/js/Contacts/ContactsController';

  const props = defineProps({
    contacts_import_controller: {}
  });

  const emit                = defineEmits(['onClosePreviewImport']);
  const contacts_controller = ContactsController;

  const onToggleContactSelection = (contact) => {
    props.contacts_import_controller.contacts_selection.toggle(contact.id, contact);
  }

  const onImportContacts = () => {
    let list_contacts_selected = props.contacts_import_controller.contacts_selection.items;
    contacts_controller.importContacts(list_contacts_selected);
    onClose();
  }

  const onClose = () => {
    emit('onClosePreviewImport')
  }

  const onResetImport = () => {
    emit('onClosePreviewImport')
  }
</script>